// Paquete del día (F3): al elegir el móvil con señal se descarga todo lo necesario para trabajar sin ella.
import { hoyISO } from '@reparto/shared/nucleo';
import { api, SinRed } from './api';
import { db } from './db';
import type { MovilLista, Paquete } from './tipos';

export async function listarMoviles(): Promise<{ datos: MovilLista[]; desdeCache: boolean }> {
  try {
    const r = await api<{ datos: MovilLista[] }>('/moviles');
    await db.moviles.put({ id: 'lista', valor: r.datos, guardado_en: new Date().toISOString() });
    return { datos: r.datos, desdeCache: false };
  } catch (e) {
    if (!(e instanceof SinRed)) throw e;
    const c = await db.moviles.get('lista');
    return { datos: c?.valor ?? [], desdeCache: true };
  }
}

export async function descargarPaquete(movilId: string, fecha = hoyISO()): Promise<Paquete> {
  const p = await api<Paquete>(`/sync/paquete-dia?movil_id=${movilId}&fecha=${fecha}`);
  await db.transaction('rw', [db.paquete, db.sesion], async () => {
    await db.paquete.put({ id: 'actual', valor: p, guardado_en: new Date().toISOString() });
    await db.sesion.update('actual', { movil_id: movilId, fecha });
  });
  return p;
}

/** Vuelve a pedir el paquete del móvil elegido (después de sincronizar o por un aviso del servidor). */
export async function refrescarPaquete(): Promise<Paquete | null> {
  const s = await db.sesion.get('actual');
  if (!s?.movil_id || !s.access_token) return null;
  return descargarPaquete(s.movil_id, s.fecha ?? hoyISO());
}

export async function soltarMovil(): Promise<void> {
  await db.transaction('rw', [db.paquete, db.sesion], async () => {
    await db.paquete.delete('actual');
    await db.sesion.update('actual', { movil_id: null, fecha: null });
  });
}
